{
  "img-alt": "Full screen image",
  "close": "Close"
}
